// English
const en = {
  badLoginInfoText:
    "Your username, or password may be incorrect, or the account may have expired.",
  toMoveItemsDragThemOnFolder: "To move items, drag them on a folder.",
  toDownloadHoldDownCtrlCmdKeyAndDragToYourDesktop:
    "To download, hold down CTRL/CMD(Mac) key and drag to your desktop.",
  pressEscToCancel: "Escを押してキャンセル",
  forItem: "For Item",
  dontShowFormForAdditionalFiles: "Don't show form for additional files",
  uploadDetails: "Upload Details",
  yes: "Yes",
  no: "No",
  areYouSureYouWantToLogOut: "Are you sure you want to log out?",
  doNotShowThisAgain: "Do not show this again",
  areYouSureYouWantToCancelThePasteAction:
    "Are you sure you want to cancel the Paste action?",
  areYouSureYouWantToCancelFileFromClosing:
    "Are you sure you want to cancel ({fileName}) file from closing?",
  areYouSureYouWantToCancelFileFromUploading:
    "Are you sure you want to cancel ({fileName}) file from uploading?",

  emailFromAndToAreRequiredFieldsOrYouCanUncheckSendEmail:
    "Email From and To are required fields or you can uncheck send email",
  alternateTempAccount: "Alternate temp account",
  username: "Username",
  password: "Password",
  confirmPassword: "Confirm Password",
  rememberMe: "Remember me",
  forgotYourPassword: "Forgot your password?",
  signIn: "Sign in",
  orContinueWith: "Or continue with",
  forgotPassword: "Forgot Password?",
  youCanRequestPasswordHere: "You can request your password here.",
  backToLogin: "Back to login",
  resetPassword: "Reset Password",
  uploadFiles: "Upload Files",
  uploadFolder: "Upload Folder",
  grid: "Grid",
  smallGrid: "Small Grid",
  mediumGrid: "Medium Grid",
  largeGrid: "Large Grid",
  list: "List",
  folderName: "Folder Name",
  "Copy Link": "Copy Link",
  sharingFiles: "Sharing Files",
  sharing: "Sharing",
  shareMethod: "Share Method",
  internalShare: "Internal Share",
  externalShare: "External Share",
  sendEmail: "Send Email",
  shareType: "Share Type",
  userNames: "User names",
  separateMultipleUsernamesWithCommas:
    "(Separate multiple usernames with commas.)",
  reference: "Reference",
  permissions: "Permissions",
  expires: "Expires",
  days: "Days",
  advanced: "Advanced",
  attachThumbnail: "Attach Thumbnail",
  attachFiles: "Attach Files",
  fullAccess: "Full Access",
  generate: "Generate",
  maximumNumberOfUses: "Maximum Number of uses",
  unlimited: "Unlimited",
  from: "From ",
  to: "To    ",
  cc: "CC ",
  bcc: "BCC ",
  replyTo: "Reply to",
  subject: "Subject",
  body: "Body",
  comments: "Comments",
  cancel: "Cancel",
  send: "Send",
  shareWindowSendButtonText: "Send",
  loginName: "Login Name",
  loginTime: "Login Time",
  sessionTimeout: "Session Timeout",
  sessionTimeoutCountdown: "(Session timeout in {time}.)",
  browserName: "Browser Name",
  browserVersion: "Browser Version",
  browserInfo: "Browser Info",
  URL: "URL",
  hostName: "Host Name",
  version: "version",
  recentActions: "Recent Actions",
  information: "Information",
  sort: "Sort",
  home: "Home",
  name: "Name",
  size: "Size",
  keywords: "Keywords",
  path: "Path",
  lastModified: "Last Modified",
  keepDirectoriesOnTopWhileSorting: "Keep directories on top while sorting",
  readOnlyFolderWarning: "This folder is read-only",
  copyright: "Copyright",
  poweredBy: "CrushFTP",
  created: "Created",
  noFilesAvailable: "No files available",
  footerFileSelectionInfo:
    "{totalFilesFolder} ({totalFolder} Folders, {totalFiles} Files)",
  footerSelectedFileInfo:
    "{totalSelectedFilesFolder} ({selectedFolder} Folder, {selectedFiles} Files) of",
  selected: "selected",
  // User Buttons
  nothingToDisplay: "Nothing to display.",
  select: "Select",
  downloadBasket: "Download Basket",
  clearAll: "Clear All",
  filter: "Filter",
  clear: "Clear",
  link: "Link",
  ok: "OK",
  toggle: "Toggle",
  allItems: "All items",
  none: "None",
  allFiles: "All Files",
  allFolders: "All Folders",
  itemStartingWithDOT: 'Item starting with "."',
  modifiedToday: "Modified today",
  modifiedThisWeek: "Modified this week",
  modifiedThisMonth: "Modified this month",
  modifiedInLast60Days: "Modified in last 60 days",
  modifiedInLast90Days: "Modified in last 90 days",
  linkCopiedToClipboard: "Link copied to clipboard",
  required: "This field is required",
  match: "Fields do not match",
  emailValidation: "Please enter a valid email address",
  phoneValidation: "Please enter a valid phone number",
  numeric: "Please enter a numeric value",
  alphanumeric: "Please enter only letters and numbers",
  "min-length": "Please enter at least {count} characters",
  "max-length": "Please enter no more than {count} characters",
  "multiple-emails":
    "Please enter a comma or semicolon separated list of valid email addresses",
  ipaddress: "Please enter a valid IP address",
  "checkbox-group": "Please select at least one option",
  copyLinkToClipboard: "Copy link to clipboard",
  openInEmailClient: "Open in Email Client",
  filesInTheBasket: "Files in the basket",

  // Search Modal
  modified: "Modified",
  sizeIs: "Size is",
  typeIsA: "Type is a",
  or: "Or",
  and: "And",
  exact: "Exact",
  searchKeywordOnly: "Search keyword only",
  startSearch: "Start Search",
  before: "Before",
  after: "After",
  smallerThan: "Smaller than",
  biggerThan: "Bigger than",
  file: "File",
  folder: "Folder",
  kilobytes: "Kilobytes",

  // User Options Modal
  hideDotItems: "Hide '.' Items",
  hideCheckboxColumn: "Hide Checkbox Column",
  hideFilterSection: "Hide Filter Section",
  whenChoosingFileToUploadAutoStartUpload:
    "When choosing file to upload, auto start upload.",
  currentPassword: "Current Password",
  newPassword: "New Password",
  phoneNo: "Phone No",
  preferences: "Preferences",
  changeYourPassword: "Change Your Password",
  save: "Save",
  generateRandomPassword: "Generate Random Password",
  changePassword: "Change Password",
  useThis: "Use This",
  setup2FactorAuth: "Setup 2 Factor Auth",
  confirm: "Confirm",
  clickHereToGenerateANewOne: "Click here to Generate a new one",
  nothingSelected: "Nothing selected",
  nothingSelectedToDownload: "Nothing selected to download",
  nothingSelectedToEditKeywords: "Nothing selected to edit keywords",
  nothingSelectedToShare: "Nothing selected to share",
  nothingSelectedToRename: "Nothing selected to rename",
  pleaseSelectFileOrFolderToCut: "Please select files/folders to cut",
  pleaseSelectFileOrFolderToCopy: "Please select files/folders to copy",
  pleaseSelectFileOrFolderToDelete: "Please select files/folders to delete",
  thereIsNothingToPaste: "There is nothing to paste",
  playSlideshow: "Play Slideshow",
  pauseSlideshow: "Pause Slideshow",

  // Upload Modal
  dragAndDropFileHere: "Drag and Drop File Here",
  addFiles: "Add files",
  uploadSelected: "Upload Selected",
  reUploadAll: "Re-Upload All",
  overwriteAll: "Overwrite All",
  resumeAll: "Resume All",
  shareUploaded: "Share Uploaded",
  shareSelected: "Share Selected",
  remove: "Remove",
  allSelected: "All Selected",
  allWithError: "All With Error",
  allUploaded: "All Uploaded",
  allCanceled: "All Canceled",
  allSkipped: "All Skipped",
  all: "All",
  scrollWithActivity: "Scroll with activity",
  totalNoFilesFailed: "Total {count} file(s) failed.",
  selectedFiles: "Selected File(s)",
  filtered: "(Filtered)",
  totalFiles: "Total File(s)",
  resume: "Resume",
  pause: "Pause",
  overwrite: "Overwrite",
  reupload: "Reupload",
  failed: "Failed",
  canceled: "Canceled",
  elapsed: "Elapsed",
  remaining: "Remaining",
  speed: "Speed",
  pausing: "Pausing",
  waiting: "Waiting",
  maxNumberOfFilesExceeded: "Max number of files exceeded",
  uploadCompleted: "アップロード完了",
  cantResumeUploadingTillDownloadingFinished:
    "Can't resume uploading till downloading finished",
  downloadingInProgress: "Downloading In Process",
  cantResumeFile: "Can't Resume File",
  directoriesCantBeUploadedSelectOnlyFiles:
    "Directories can not be uploaded, select only files",
  uploadingDirectoryIsNotAllowed: "Uploading directory is not allowed",
  downloadingCannotBeginUntilUploadingProcessIsCompleted:
    "アップロードが完了するまでダウンロードは開始できません。",
  uploadingInProgressPleaseWait: "アップロードが進行中です。少しお待ち下さい。",
  cantResumeDownloadingTillUploadingFinished:
    "アップロードが完了するまでダウンロードは再開できません。",
  uploadingInProgress: "アップロードの処理中です",
  serverNotConfiguredForEmailError:
    "このサーバはパスワード備忘録の送信が設定されていません。",

  filesToUpload: "アップロードするファイル",
  welcomeForm: "Welcome Form",
  readyToScan: "Ready to Scan",
  cantMoveItemsToSameFolder: "Can't move item(s) to same folder",
  pleaseSelectUserPassForTheShare: "Please select user/pass for the share",
  selectedUserPassForTheShareWasDeniedPleaseChooseOtherUserPass:
    "Selected user/pass for the share was denied, please choose other user/pass",
  fileAddedToBasket: "File Added To Basket",
  invalidUserName: "Invalid User Name",
  invalidUserNameDetails: "Invalid User Name Details",
  multipleBadLoginsAlert:
    "Too many failed attempts and your IP will be banned.\r\n\r\n{msg}<br><br><div style='font-size:13px;font-weight:normal;'>Click <a class='text-accentMain' href='/WebInterface/new-ui/reset.html'>here</a> to reset password.</div>",
  pleaseValidateCaptchaToLogin: "Please validate captcha to login",
  enterValidUsername: "Enter valid username",
  loginFailed: "Login Failed",
  success: "Success",
  loadingWebInterface: "Loading WebInterface",
  cantHandleThisActionJustYet: "Can't handle this action just yet",
  workInProgress: "Work in progress",
  onlyFilesCanCutCopy: "Only files can cut/copy",
  thereWasSomeProblemWhileUpdatingKeywordsForTheSelectedItemsPleaseTryAgain:
    "There was some problem while updating keywords for the selected items, please try again",
  thereWasSomeProblemWhileDeletingSelectedItemsPleaseTryAgain:
    "There was some problem while deleting selected items, please try again",
  thereWasSomeProblemWhileRenamingSelectedItemsPleaseTryAgain:
    "There was some problem while renaming selected item, please try again",
  thereWasSomeProblemWhileCreatingAFolderPleaseTryAgain:
    "There was some problem while creating a folder, please try again",
  downloadWillStartOnceOngoingUploadIsCompleted:
    "Download will start once ongoing upload is completed",
  uploadWillStartOnceOngoingDownloadIsCompleted:
    "Upload will start once ongoing download is completed",
  note: "Note",

  // Header Buttons
  "Create Folder": "Create Folder",
  Download: "Download",
  "Zip Download": "Zip Download",
  "Advanced Download": "Advanced Download",
  Search: "Search",
  Paste: "Paste",
  Copy: "Copy",
  Cut: "Cut",
  Upload: "Upload",
  Rename: "Rename",
  Delete: "Delete",
  Share: "Share",
  "Add To Basket": "Add To Basket",
  "Show Basket": "Show Basket",
  Slideshow: "Slideshow",
  Admin: "Admin",
  "User Options": "User Options",
  "Edit Keywords": "Edit Keywords",
  Logout: "Logout",
  "Manage Shares": "Manage Shares",
  "Quick Share": "Quick Share",
  "Custom Share": "Custom Share",
  Custom: "Custom",
  "Change Icon": "Change Icon",

  uploadNotAllowed: "Upload not allowed",
  youDoNotHavePermissionToUpload: "You don't have permission to upload",

  expandAll: "Expand All",
  collapseAll: "Collapse All",
  Actions: "Actions",

  theServerIsUnavailableOrYourIPHasBeenRemoved:
    "The server is unavailable or your IP has been banned",
  problemWhileLoadingGoogleSignInLibrary:
    "Problem while loading Google sign in library",
  problemWhileLoadingMicrosoftSignInLibrary:
    "Problem while loading Microsoft sign in library",
  problemWithMicrosoftSignInLibraryConfiguration:
    "There are some configuration issues with Microsoft sign in, please check",

  report: "Report",

  downloadHasStarted: "Download has started",
  pleaseSelectZipToExplore: "Please select zip to explore",
  "Create Folder And Share": "Create Folder And Share",
  "Download All": "Download All",
  "Download Keywords": "Download Keywords",
  "Edit file (for context menu only)": "Edit file (for context menu only)",
  "Expand/Collapse All Items": "Expand/Collapse All Items",
  "Explore zip contents": "Explore zip contents",

  pleaseSelectFileToUnZip: "Please select file to unzip",
  pleaseSelectFileToZip: "Please select file to zip",
  rightClickOnItemAndClickOnUpdateKeywords:
    "Right click on item and click on update keywords",
  Group: "Group",
  Help: "Help",
  QuickView: "QuickView",
  "Report A Problem": "Report A Problem",
  "Show History": "Show History",
  Unzip: "Unzip",
  "Zip Selected": "Zip Selected",
  ZipDownload: "ZipDownload",
  CSVExport: "CSVExport",
  NewUI: "NewUI",
  "Download Low-Res": "Download Low-Res",
  "Create Folder & Share": "Create Folder & Share",
  BatchComplete: "BatchComplete",

  filterApplied: "Filter Applied",

  customEventInitiated: "Custom Event Initiated",
  thereWasSomeProblemWhileRunningCustomEvent:
    "There was a problem while running custom event",
  failure: "Failure",
  transferAcknowledged: "Transfers Acknowledged",
  result: "Result",

  uploadingCanceled: "Uploading Canceled",
  downloadingCanceled: "Downloading Canceled",
  downloadCompleted: "Download Completed",
  zoomIn: "Zoom In",
  zoomOut: "Zoom Out",
  previousSlide: "Previous Slide",
  nextSlide: "Next Slide",
  rotateImageLeft: "Rotate Image Left",
  rotateImageRight: "Rotate Image Right",

  nowAddFilesFromUploadBar: "Now add files from upload bar",
  useUploadBarToAddFilesToUploadClickOnAddFilesButtonToAddFiles:
    "Use upload bar to add files to upload. Click on 'Add files...' button to add files",
  publishCompleted: "Publish completed",
  publishFailed: "Publish Failed",
  sendingEmailFailed: "Sending email failed",

  pleaseEnterFolderName: "Please enter folder name",
  nothingSelectedToAddToTheBasket: "Nothing selected to add to the basket",
  selectedFileIsAlreadyAvailableInTheBasket:
    "Selected file is already available in the basket",
  fileAlreadyAddedToTheBasket: "File already added to the basket",
  navigateAfterCreating: "Navigate after creating",
  creatingFolderAt: "Creating folder at",

  "Set Meta Property": "Set Meta Property",
  submit: "Submit",
  Preview: "Preview",
  startOver: "Start Over",
  generatePassword: "Generate Password",
  usernameOrEmail: "Username Or Email",
  create: "Create",
  copyToClipboard: "Copy To Clipboard",
  customTheme: "Custom Theme",
  lightTheme: "Light Theme",
  darkTheme: "Dark Theme",
  resetTheme: "Reset Theme",
  close: "Close",
  accent: "Accent",
  accentSecondary: "Accent Secondary",
  backgroundPrimary: "Background Primary",
  backgroundSecondary: "Background Secondary",
  textPrimary: "Text Primary",
  textSecondary: "Text Secondary",

  onlyAFileCanBeSelected: "Only a file can be selected.",
  downloadingFolderAreNotSupported: "Downloading folder are not supported.",
  onlyOneFileCanBeSelectedAtATime: "Only one file can be selected at a time.",
  downloadingMultipleFilesNotSupported:
    "Downloading multiple files not supported.",

  last10SecAverageSpeed: "Last 10 Sec Avg Speed",

  cookiesAcceptNotification:
    "We use cookies on this site to facilitate your ability to login for technical reasons.",
  cookiePolicy: "Cookie Policy",
  accept: "Accept",
  dismiss: "Dismiss",

  autoLogoutText: "You are about to log out due to inactivity",
  autoLogoutTitle: "Auto Logout",
  stayLoggedIn: "Stay Logged In",
  ignore: "Ignore",
  loggedOutDueToInactivity:
    "You are logged out due to inactivity. Please login to continue.",
  login: "Login",

  youMustChangeYourPasswordToContinue:
    "You must change your password to continue.",
  pleaseLoginAgain: "Please login again",
  loginWithNewPassword: "Login with new password",

  canceling: "Canceling",
  items: "Items",
  available: "Available",
  protocol: "Protocol",

  averageSpeed: "Average Speed",
  finalizing: "Finalizing",
  details: "Details",
  finalizingCopyingDataFromTempFileToFinalCompleteFilePleaseWait:
    "コピー済みデータを中間ファイルから完了処理をしています。少しお待ち下さい。",

  areYouSureYouWantToDeleteSelectedItem:
    "Are you sure you want to delete selected items?",
  yesDelete: "Yes, Delete",
  updatingKeywords: "Updating keywords",
  htmlNotAllowedItWillStripDownHTMLWhileSaving:
    "HTML not allowed, it will strip down HTML while saving",
  appendKeywords: "Append to existing keywords",
  dependingOnMachineThisMayTakeApprox:
    "Depending on Machine performance, Disk-speed and AntiVirus & Anti-Malware protections this could take approximately",

  deleteSlide: "Delete Slide",
  refreshSlideshow: "Refresh Slideshow",
  toggleFullScreen: "Toggle Fullscreen",
  "Sync Manager": "Sync Manager",
  downloadedInSecAtAnAverageSpeed:
    "Downloaded in {time} at an average speed of {speed}",
  uploadedInSecAtAnAverageSpeed:
    "Uploaded in {time} at an average speed of {speed}",
  maxFileAllowedTouploadExceeded:
    "Max number of files allowed to upload exceeded, maximum files allowed to upload: {count}",
  sandBoxDownloadMessage:
    "File is downloaded and being saved by browser, please monitor browser download bar.",
  smtpFailedToSendTheEmail: "SMTP failed to send the email. Check server log",

  shareDetails: "Share Details",
  editShare: "Edit Share",
  prev: "Prev",
  next: "Next",
  edit: "Edit",
  remainingUses: "Remaining Uses",
  attachedInEmail: "Attached in Email?",
  uploadAllowed: "Upload Allowed?",
  paths: "Paths",
  areYouSureYouWantToDeleteSelectedAccounts:
    "Are you sure you wish to delete selected {count} account(s)?",
  selectShareAccountWithTypeLike: "Select share accounts with {type} like",
  exactMatch: "Exact Match",
  deleteSelectedItems: "Delete Selected Items",
  selectMatchingAccounts: "Select Matching Accounts",
  openInASeparateWindow: "Open in a separate window",

  noMatchingAccountFound: "No matching account found.",
  removeAll: "Remove All",
  selectSimilar: "Select Similar",

  removeField: "Remove Field",
  yesRemove: "Yes, Remove",
  areYouSureYouWantToRemoveSelectedField:
    "Are you sure you wish to remove selected field(s)?",

  typeInASearchTerm: "Type in a search term",
  searching: "Searching",
  availableUsers: "Available Users",
  selectedUsers: "Selected Users",
  addSelected: "Add Selected",
  removeSelected: "Remove Selected",
  selectMultipleUserQuickly: "Select multiple users quickly",

  enterYourOTPHere: "Enter your OTP here",
  youDoNotHavePermissionToDeleteFolder:
    "You don't have permission to perform delete operation on folders",

  setToDefault: "Set to default",
  arrangeFileListingTableColumns: "Arrange File Listing Table Columns",
  arrangeColumns: "Arrange Columns",

  folderWithTheSameNameAlreadyExistsPleaseSelectDifferentName:
    "A folder with the same name already exists. Please select a different name.",
  showingSearchResult: "Showing Search Result",

  downloads: "Downloads",
  uploads: "Uploads",
  deletes: "Deletes",
  renames: "Renames",
  "Subscribe To Events": "Subscribe To Events",
  update: "Update",

  reuploadConfirmationMessage:
    "It will re-upload all files which are already uploaded, canceled, skipped or failed while uploading and it will overwrite existing files. Are you sure you want to continue?",
  uploading: "Uploading",
  skip: "Skip",

  areYouSureYouWantToCancelUploading:
    "Are you sure you want to cancel uploading?",
  areYouSureYouWantToCancelParticularFileFromUploading:
    "Are you sure you want to cancel ({file}) file from uploading?",
  areYouSureYouWishToCancelUploadForLastSelectedItems:
    "Are you sure you wish to cancel upload for last selected {length} item(s)?",

  downloading: "Downloading",

  socketUpload: "Socket Upload",
  socketDownload: "Socket Download",
  enabled: "Enabled",
  disabled: "Disabled",
  range: "Range",
  editAFile: "Edit a file",
  somethingWentWrongWhileOpeningTheFile:
    "Something went wrong while opening the file.",
  somethingWentWrongWhileSavingTheFile:
    "Something went wrong while saving the file.",
  fileSaved: "File saved",

  allFilesAreUploadedSuccessfully: "All files are uploaded successfully",
  warning: "Warning",
  largeDirListingDefaultWarning:
    "Large directory listings cause significant performance issues. We suggest organizing items into subfolders to prevent performance issues.",
  zipFileName: "ZIP file name",
  largeUploadListingDefaultWarning:
    "Selecting large amount files to upload with web uploader is not recommended, you might face performance issues. We suggest using zip to combine files.",
  dragAndDropFileAndFoldersHereToUpload:
    "Drag & Drop Files and Folders Here To Upload",
  auto: "Auto",
  userPassword: "Username/Password",
  directLink: "Direct link to file?",
  move: "Move",

  areYouSureYouWantToDeleteSubscribeEventsOfDirectory: `Are you sure you want delete subscribe events of ({path}) directory?`,
  "Manage Subscribed Events": "Manage Subscribed Events",
  subscribedEventsAreSuccessfullyUpdated:
    "Subscribed Events are successfully updated",
  subscribeEventsHasBeenDeleted: "Subscribed Events has been deleted",
  notMe: "Not me",
  continueAs: "Continue as",
  subscribedToEventsCount: "Subscribed to {eventCounts} event(s)",

  view: "View",
  deleteFolder: "Delete Folder",
  history: "History",
  refresh: "Refresh",
  quit: "Quit",
  shareHistory: "Share History",
  clearLocalHistory: "Clear Local History",
  removeFromLocalHistory: "Remove From Local History",
  minutesAgo: "minute(s) ago",
  hoursAgo: "hour(s) ago",
  secondsAgo: "second(s) ago",
  daysAgo: "day(s) ago",
  server: "Server",
  user: "User",
  port: "Port",
  tryNow: "Try now",
  tryingToReconnectElectronApp:
    "We have lost connection to the server... trying to reconnect...",
  alternateTempaccountInfo:
    "Use this field to set alternate TempAccount while sharing, 'TempAccount_' will be added as a prefix to the name used here.",
  hideDownloadButton: "Hide Download Button",
  quickFilter: "Quick Filter",
  searchEllipsis: "Search...",
  type: "Type"
};

export default en;
